import { LocalisationHelper } from '@/helpers/LocalisationHelper';

const isMenuEmpty = (menuData) => {
  if (!menuData) {
    return true;
  }

  if (Array.isArray(menuData) && menuData.length === 0) {
    return true;
  }

  if (typeof menuData === 'object') {
    return Object.keys(menuData).length === 0;
  }

  return false;
};

const areCountriesEmpty = (countries) => {
  return !Array.isArray(countries) || countries.length === 0;
};

export default async function dataLoader(context) {
  if (process.server) {
    return;
  }

  const { app, store } = context;

  const needsMenu = isMenuEmpty(store.state.shop.menu.data);
  const needsCountries = areCountriesEmpty(store.state.shop.localisation.countries);

  if (!needsMenu && !needsCountries) {
    return;
  }

  console.info('[DataLoader] Reloading critical data', {
    needsMenu,
    needsCountries,
  });

  const tasks = [];

  if (needsCountries) {
    const helper = new LocalisationHelper(
      app.$http,
      store,
      app.$auth,
      app.i18n && app.i18n.locale ? app.i18n.locale : 'fr'
    );

    tasks.push(helper.setListCountries());
  }

  if (needsMenu) {
    tasks.push(store.dispatch('shop/menu/fetchMenu'));
  }

  try {
    await Promise.all(tasks);
  } catch (error) {
    console.error('[DataLoader] Failed to load critical data:', error);
  }
}
